/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Authentication } from './Authentication';
import {
    AuthenticationFromJSON,
    AuthenticationFromJSONTyped,
    AuthenticationToJSON,
    AuthenticationToJSONTyped,
} from './Authentication';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';
import type { PersonType } from './PersonType';
import {
    PersonTypeFromJSON,
    PersonTypeFromJSONTyped,
    PersonTypeToJSON,
    PersonTypeToJSONTyped,
} from './PersonType';

/**
 * 
 * @export
 * @interface UserToken
 */
export interface UserToken {
    /**
     * 
     * @type {string}
     * @memberof UserToken
     */
    aud?: string;
    /**
     * 
     * @type {string}
     * @memberof UserToken
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof UserToken
     */
    iat?: number;
    /**
     * 
     * @type {number}
     * @memberof UserToken
     */
    exp?: number;
    /**
     * 
     * @type {number}
     * @memberof UserToken
     */
    nbf?: number;
    /**
     * 
     * @type {string}
     * @memberof UserToken
     */
    iss?: string;
    /**
     * 
     * @type {string}
     * @memberof UserToken
     */
    sub?: string;
    /**
     * 
     * @type {string}
     * @memberof UserToken
     */
    prev_token_id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserToken
     */
    oid?: string;
    /**
     * Person ID
     * @type {string}
     * @memberof UserToken
     */
    person_id?: string;
    /**
     * 
     * @type {PersonType}
     * @memberof UserToken
     */
    person_type?: PersonType;
    /**
     * 
     * @type {boolean}
     * @memberof UserToken
     */
    first_token?: boolean;
    /**
     * 
     * @type {Array<Authentication>}
     * @memberof UserToken
     */
    authentications?: Array<Authentication>;
    /**
     * 
     * @type {Array<FactorMethod>}
     * @memberof UserToken
     */
    authenticated_methods?: Array<FactorMethod>;
    /**
     * 
     * @type {string}
     * @memberof UserToken
     */
    groups_claim_name?: string;
    /**
     * The ID of the anonymous person used before the sign-in (if any)
     * @type {string}
     * @memberof UserToken
     */
    prev_anonymous_person_id?: string;
}



/**
 * Check if a given object implements the UserToken interface.
 */
export function instanceOfUserToken(value: object): value is UserToken {
    return true;
}

export function UserTokenFromJSON(json: any): UserToken {
    return UserTokenFromJSONTyped(json, false);
}

export function UserTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserToken {
    if (json == null) {
        return json;
    }
    return {
        
        'aud': json['aud'] == null ? undefined : json['aud'],
        'id': json['id'] == null ? undefined : json['id'],
        'iat': json['iat'] == null ? undefined : json['iat'],
        'exp': json['exp'] == null ? undefined : json['exp'],
        'nbf': json['nbf'] == null ? undefined : json['nbf'],
        'iss': json['iss'] == null ? undefined : json['iss'],
        'sub': json['sub'] == null ? undefined : json['sub'],
        'prev_token_id': json['prev_token_id'] == null ? undefined : json['prev_token_id'],
        'oid': json['oid'] == null ? undefined : json['oid'],
        'person_id': json['person_id'] == null ? undefined : json['person_id'],
        'person_type': json['person_type'] == null ? undefined : PersonTypeFromJSON(json['person_type']),
        'first_token': json['first_token'] == null ? undefined : json['first_token'],
        'authentications': json['authentications'] == null ? undefined : ((json['authentications'] as Array<any>).map(AuthenticationFromJSON)),
        'authenticated_methods': json['authenticated_methods'] == null ? undefined : ((json['authenticated_methods'] as Array<any>).map(FactorMethodFromJSON)),
        'groups_claim_name': json['groups_claim_name'] == null ? undefined : json['groups_claim_name'],
        'prev_anonymous_person_id': json['prev_anonymous_person_id'] == null ? undefined : json['prev_anonymous_person_id'],
    };
}

export function UserTokenToJSON(json: any): UserToken {
    return UserTokenToJSONTyped(json, false);
}

export function UserTokenToJSONTyped(value?: UserToken | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'aud': value['aud'],
        'id': value['id'],
        'iat': value['iat'],
        'exp': value['exp'],
        'nbf': value['nbf'],
        'iss': value['iss'],
        'sub': value['sub'],
        'prev_token_id': value['prev_token_id'],
        'oid': value['oid'],
        'person_id': value['person_id'],
        'person_type': PersonTypeToJSON(value['person_type']),
        'first_token': value['first_token'],
        'authentications': value['authentications'] == null ? undefined : ((value['authentications'] as Array<any>).map(AuthenticationToJSON)),
        'authenticated_methods': value['authenticated_methods'] == null ? undefined : ((value['authenticated_methods'] as Array<any>).map(FactorMethodToJSON)),
        'groups_claim_name': value['groups_claim_name'],
        'prev_anonymous_person_id': value['prev_anonymous_person_id'],
    };
}

